/**
 * <strong>Properties:</strong><br>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DescriptionMixin|description}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DisabledMixin|disabled}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/EditableMixin|editable}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/HorizontalAlignmentMixin|horizontalAlignment}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/PlaceholderMixin|placeholder}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/SizeMixin|width, height}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/TagMixin|tag}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/TextInputValueMixin|value}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/ValidationMixin|validationState, errorText, warningText}</li>
 * <br>
 * <br>
 * <strong>Events:</strong>
 * <br>
 * <br>
 * <li>{@link module:mw-form/mixins/event/ChangeEventMixin|change}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/event/TypingEventMixin|typing}</li>
 * <br>
 * <br>
 * <strong>Example:</strong>
 * <br>
 * <br>
 * For a working example, see the {@link http://inside-files/dev/eps/WIT/WebWidgets/Gallery/Gallery/#textfield_anchor|gallery}
 * <br>
 * <br>
 * @module mw-form/TextField
 *
 * @copyright Copyright 2015-2016 The MathWorks, Inc.
 */

// TODO: Remove _CSSStateMixin dependency, as seen in SplitButton and ToggleSplitButton

define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/keys",
    "dojo/on",
    "dijit/_WidgetBase",
    "dijit/_Contained",
    "dijit/_CssStateMixin",
    "dijit/_FocusMixin",
    "dijit/_TemplatedMixin",

    "mw-form/mixins/property/TagMixin",
    "mw-form/mixins/property/DescriptionMixin",
    "mw-form/mixins/property/DisabledMixin",
    "mw-form/mixins/property/HorizontalAlignmentMixin",
    "mw-form/mixins/property/EditableMixin",
    "mw-form/mixins/property/SizeMixin",
    "mw-form/mixins/property/TextInputValueMixin",
    "mw-form/mixins/SharedTextInputMixin",
    "mw-form/mixins/property/PlaceholderMixin",
    "mw-form/mixins/property/VisualFamilyMixin",
    "mw-form/mixins/property/ValidationMixin",
    "mw-form/mixins/mixinDependencyValidator",
    // events
    "mw-form/mixins/event/ChangeEventMixin",
    "mw-form/mixins/event/TypingEventMixin",

    "dojo/text!./templates/TextField.html"

], function (declare, lang, keys, on, _WidgetBase, _Contained, _CssStateMixin, _FocusMixin,
             _TemplatedMixin, TagMixin, DescriptionMixin, DisabledMixin, HorizontalAlignmentMixin,
             EditableMixin, SizeMixin, TextInputValueMixin, SharedTextInputMixin, PlaceholderMixin, VisualFamilyMixin, ValidationMixin, mixinDependencyValidator, ChangeEventMixin,
             TypingEventMixin, template) {

    return declare(mixinDependencyValidator.validate([_WidgetBase, _Contained, _CssStateMixin, _FocusMixin, _TemplatedMixin, TagMixin, DescriptionMixin,
        DisabledMixin, HorizontalAlignmentMixin, EditableMixin, SizeMixin, TextInputValueMixin,
        SharedTextInputMixin, PlaceholderMixin, VisualFamilyMixin, ValidationMixin, ChangeEventMixin, TypingEventMixin]), {

        baseClass: "mwWidget mwTextField",
        templateString: template,

        /* Overriding from  Horizontal Alignment Mixin*/
        horizontalAlignment: "left",

        /* Overriding from  Size Mixin*/
        width: 150,

        height: 22,

        constructor: function(){

            // For TextFields, pressing Enter should not trigger the 'typing' event.
            // 'Enter' is not excluded in the SharedTextInputMixin because for the TextArea,
            // pressing enter creates a new line, thus should trigger the 'typing' event.
            this._addKeysThatPreventTypingEvent([keys.ENTER]);
        },

        postCreate: function () {
            this.inherited(arguments);
            this.own(on(this.inputNode, "focus", this._focusHandler.bind(this)));
            this.own(on(this.inputNode, "blur", this._blurHandler.bind(this)));
        },

        _focusHandler: function () {
            this.domNode.classList.add("mwTextFieldInputNodeFocused");
        },

        _blurHandler: function () {
            this.domNode.classList.remove("mwTextFieldInputNodeFocused");
        },

        // _handleEnterKey method fires a change event and highlights the textfield on pressing ENTER key
        _handleEnterKey: function () {

            var textInputValue,
                oldValue,
                newValue;

            textInputValue = this.inputNode.value;

            oldValue = this.get("value");
            this.set("value", textInputValue);
            newValue = this.get("value");

            if (oldValue !== newValue) {
                this._triggerChangeEvent("value", oldValue, newValue);
            }

            //textFieldCommitHighlight - highlights the input field when enter key is pressed by adding/removing the 'mwTextFieldHighlight' class
            this.domNode.classList.add("mwTextFieldHighlight");

            /* If we use setTimeout, need to destroy the handle using clear Interval explicitly in destroy method of widget life cycle.
             *  Widget base has defer method that does the clean up automatically
             */
            this.defer(
                lang.hitch(this, function () {
                    this.domNode.classList.remove("mwTextFieldHighlight");
                }),
                200
            );
        },

        // overriding the _onKeyUp event listener from sharedTextInputMixin
        _onKeyUp: function (e) {

            this.inherited(arguments);

            // when enter is pressed a change event is fired and highlights the textfield
            if (e.keyCode === keys.ENTER) {

                this._handleEnterKey();
            }

        },

        _qeTypeOverWithEnter: function (value) {
            // _WidgetBase's emit method
            var qeOldValue = this.get("value");
            this.set("value", value);
            var evt = new KeyboardEvent("keydown", {key: "Enter", code: "Enter", keyCode: 13, which: 13});
            this.inputNode.dispatchEvent(evt);
            evt = new KeyboardEvent("keyup", {key: "Enter", code: "Enter", keyCode: 13, which: 13});
            this.inputNode.dispatchEvent(evt);
        },

        _setDisabledAttr: function (disabled) {
            this.inherited(arguments);
            if(disabled === true) {
                this.inputNode.setAttribute("disabled", "");
            } else {
                this.inputNode.removeAttribute("disabled");
            }
        }

    });

});
